import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { BUSQUEDA, ERASER } from "../../../components/iconsSVG/IconsSVG";

const BusquedaTomos = ({ onSearch, tomo, onRecargarResultados, onLimpiarFiltros }) => {
  const [loading, setLoading] = useState(false);

  const realizarBusqueda = async () => {
    setLoading(true);
    onSearch();
   /* try {
      const resultados = await busquedaTomos(tomo);
      onRecargarResultados(body, resultados);
    } catch (error) {
      console.error("Error al realizar la búsqueda:", error, loading);
    } finally {
      setLoading(false);
    }*/
  };

  const limpiarResultadosYFiltros = () => {
    // onRecargarResultados(tomo, []);
    onLimpiarFiltros(tomo);
  };

  return (
    <div className="mb-3">
    <Row  className="p-3 m-0 gap-3">
      <Col xs="auto" className="d-flex justify-content-center p-0 m-0 mb-1 mb-lg-0 ">
        <Button className="btn-azul" onClick={realizarBusqueda}>
          <BUSQUEDA />&nbsp;&nbsp;BUSCAR
        </Button>
      </Col>        
      <Col xs="auto" className="d-flex justify-content-center p-0 m-0 mb-1 mb-lg-0">
        <Button className="btn-blue-border" onClick={limpiarResultadosYFiltros}>
          <ERASER />&nbsp;&nbsp;LIMPIAR
        </Button>
      </Col>
    </Row>
    </div>
  );
};

export default BusquedaTomos;
